import { useBackendApi } from 'nekst-api';

export type PersonParseResult = {
  id?: number;
  firstName: string;
  lastName: string;
  addressLine1?: string
  addressLine2?: string
  city?: string
  state?: string
  zip?: string
  phoneNumber?: string
  companyName?: string
  website?: string
  email?: string
  roleId?: number
  context: number[]
}

export type PromptParseResult = {
  id: string
  type: 'S' | 'N' | 'B' | 'D'
  prompt: string
  value: string
  context: number[]
}

export type PdfParseResult = {
  people: PersonParseResult[],
  tasks: PromptParseResult[],
  fileText: string
}

export type ParsePrompt = {
  type: 'S' | 'N' | 'B' | 'D'
  prompt: string
  id: string
}

export type PdfParseRequest = {
  file: string
  prompts: ParsePrompt[],
  aiModel?: string,
}

export default function useAiParserService() {
  const backendService = useBackendApi();

  const parseDocument = async (request: PdfParseRequest) => {
    return await backendService.post(`/projects/launchdata`, {
      ...request,
    }) as PdfParseResult;
  };

  return {
    parseDocument,
  };
}
